import * as React from "react";
import Loadable from "react-loadable";

// TODO: add editor loading state

export default Loadable({
  loader: () => import("./Editor"),
  loading: () => <div />
});
